import { useI18n } from "@/i18n/translations";
import { iniziative, lectiones, master } from "@/data/events";
import { pubblicazioni } from "@/data/publicazioni";
import { Seo } from "@/components/Seo";
import { FotoSlot, NoteCard, PageHeader } from "@/components/Editorial";
import { Reveal } from "@/components/Reveal";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/** Pagina-indice di Attività: ogni categoria è una pagina autonoma raggiungibile dal sottomenu. */
const CATEGORIE = [
  { path: "/attivita/iniziative", titleKey: "nav.att_iniziative", descKey: "att.cat_iniziative_desc", n: iniziative.length, testid: "att-cat-iniziative" },
  { path: "/attivita/lectiones", titleKey: "nav.att_lectiones", descKey: "att.cat_lectiones_desc", n: lectiones.length, testid: "att-cat-lectiones" },
  { path: "/attivita/master", titleKey: "nav.att_master", descKey: "att.cat_master_desc", n: master.length, testid: "att-cat-master" },
  { path: "/attivita/pubblicazioni", titleKey: "nav.att_pubblicazioni", descKey: "att.cat_pubblicazioni_desc", n: pubblicazioni.reduce((s, a) => s + a.sezioni.reduce((x, sec) => x + sec.voci.length, 0), 0), testid: "att-cat-pubblicazioni" },
];

export const Attivita = () => {
  const { t } = useI18n();
  return (
    <>
      <Seo titleKey="seo.attivita.title" descKey="seo.attivita.desc" path="/attivita" />
      <PageHeader
        kickerKey="att.kicker"
        titleKey="att.title"
        aside={
          <FotoSlot
            src="https://thumb.wikimedia.org/wikipedia/commons/thumb/0/00/Genova_Universit%C3%A0_di_Genova_Cortile_8.jpg/960px-Genova_Universit%C3%A0_di_Genova_Cortile_8.jpg"
            captionKey="foto.attivita"
            testid="foto-attivita"
            ratio="aspect-[21/9] sm:aspect-auto sm:min-h-[140px]"
            fill
          />
        }
      >
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-mutedtx">{t("att.intro_reale")}</p>
      </PageHeader>

      <div className="container-x grid gap-6 py-16 sm:py-20 md:grid-cols-2" data-testid="attivita-categorie">
        {CATEGORIE.map((c, i) => (
          <Reveal key={c.path} delay={i * 0.06}>
            <Link to={c.path} data-testid={c.testid} className="group flex h-full flex-col justify-between border border-borderc bg-cardwhite p-8 transition-colors hover:border-bordeaux/60">
              <div>
                <div className="flex items-baseline justify-between gap-4">
                  <span className="font-serif text-sm italic text-bordeaux">{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-[12px] uppercase tracking-[0.14em] text-mutedtx">{c.n} {t("att.cat_schede")}</span>
                </div>
                <h2 className="mt-5 font-serif text-2xl font-medium leading-snug text-ink transition-colors group-hover:text-bordeaux sm:text-3xl">{t(c.titleKey)}</h2>
                <p className="mt-3 text-sm leading-relaxed text-bodytx/85">{t(c.descKey)}</p>
              </div>
              <span className="mt-8 inline-flex items-center gap-2 text-[13px] font-semibold uppercase tracking-[0.12em] text-bordeaux">
                {t("common.esplora")}
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>

      <div className="container-x pb-20 sm:pb-24">
        <Reveal>
          <NoteCard title={t("att.nota_title")}>{t("att.nota_text")}</NoteCard>
        </Reveal>
      </div>
    </>
  );
};

export default Attivita;
